import { gql } from '@apollo/client';

export const ADD_CREW_MEMBER_LOCATION_CHANGE = gql`
	mutation addLocationChange($input: CrewMemberLocationChangeInput!) {
		addLocationChange(input: $input) {
			... on CrewMemberLocationChangeSuccessResponse {
				__typename
				locationChange {
					id
					crewMemberId
					city {
						id
						name
						timezone
					}
					effectiveTimestamp
					note
					updatedAt
					updatedBy
				}
			}
		}
	}
`;
